<template>
	<div data-tour-scope="ebay-list">
		<!--		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%" width="350">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>-->
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> Ebay</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>

							<v-spacer></v-spacer>
							<CatalogActions platform="ebay" :fallback-marketplaces="marketplaceFilterOptions" @applied="getSearch()" />
							<v-toolbar-items shift>
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
							</v-toolbar-items>
							<template v-slot:extension>
								<MarketplaceTabs platform="ebay" />
							</template>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="4">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-select
										v-model="settings.filters.marketplace"
										:items="marketplaceFilterOptions"
										item-text="text"
										item-value="value"
										label="Cerca marketplace"
										outlined
										dense
										clearable
										hide-details
										@change="applyTableFilters"
									></v-select>
								</v-col>
								<v-col cols="12" md="4">
									<v-select v-model="settings.filters.status" :items="statusFilterOptions" label="Status" outlined dense clearable hide-details @change="applyTableFilters"></v-select>
								</v-col>
							</v-row>
						</v-col>
						<v-data-table
							v-model="selectedall"
							data-tour="table"
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni inserzione diventa una card chiave/valore con i campi modificabili -->
								<tbody v-if="mobileCards" class="ebay-cards">
									<tr v-for="(item, index) in items" :key="index">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.item || 'Prodotto'" :fields="campiCard(item)" :image="createImage(item)" :image-fallback="imagePlaceholder">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-sync" @click="deleteSync(item)">
																<v-list-item-title>Elimina sincronizzazione </v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteMarketplace(item)">
																<v-list-item-title>Elimina da cms/marketplace </v-list-item-title>
															</v-list-item>
															<v-list-item v-if="item.status === 'Confirmed'" link data-tour="row-edit" @click="editMarketplace(item)">
																<v-list-item-title>Modifica su cms/marketplace </v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-detail" @click="editItem(item)">
																<v-list-item-title>Visualizza dettaglio prodotto </v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center mb-2">
														<img :src="getImageMarketplace(item.platform)" :alt="item.platform" style="width: 30px; margin-right: 5px" />
														<img :src="getEbayMarketplaceFlag(item.marketplace)" :alt="item.marketplace" style="width: 25px" />
														<a :href="item.url" target="_blank" v-if="item.url" class="ml-2 d-flex" title="Apri l'inserzione su eBay"
															><img :src="require(`@/assets/images/www.svg`)" :alt="item.url" style="width: 24px"
														/></a>
													</div>
												</template>
												<ebay-seller-fields
													:item="item"
													:shipping-items="createListMarketplace(item)"
													@price="changePriceMarketplace"
													@quantity="changeQuantityMarketplace"
													@shipping="changeShippingMarketplace"
												/>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!items.length">
										<td :colspan="headers.length" class="text-center grey--text py-6">Nessuna inserzione</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="(item, index) in items" :key="index">
										<!-- v-bind:class="toggleClass(1)"-->
										<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->

										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-sync" @click="deleteSync(item)">
														<v-list-item-title>Elimina sincronizzazione </v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-delete" @click="deleteMarketplace(item)">
														<v-list-item-title>Elimina da cms/marketplace </v-list-item-title>
													</v-list-item>
													<v-list-item v-if="item.status === 'Confirmed'" link data-tour="row-edit" @click="editMarketplace(item)">
														<v-list-item-title>Modifica su cms/marketplace </v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-detail" @click="editItem(item)">
														<v-list-item-title>Visualizza dettaglio prodotto </v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>

										<td>
											{{ item.status }}
										</td>

										<td>
											{{ item.createdDate | moment('DD/MM/YYYY') }}
										</td>

										<td>
											<v-img class="mt-1 mb-1" max-height="100" max-width="100" :ref="index" :src="createImage(item)" @error="imageUrlAlt(index)"></v-img>

											<!---->
										</td>
										<td class="stack-cell">
											<div v-if="item.item" class="stack-title">{{ item.item }}</div>
											<div v-if="item.sku"><span class="stack-label">SKU</span> {{ item.sku }}</div>
											<div v-if="item.ean"><span class="stack-label">EAN</span> {{ item.ean }}</div>
											<div v-if="item.qt !== undefined && item.qt !== null">
												<span class="stack-label">Qtà</span> {{ item.qt }}
												<template v-if="item.qtunit"> · <span class="stack-label">Unità</span> {{ item.qtunit }}</template>
											</div>
											<div v-if="formatPrice(item.price)"><span class="stack-label">Prezzo</span> {{ formatPrice(item.price) }} {{ item.currency }}</div>
										</td>
										<td class="stack-cell">
											<div class="d-flex align-center mb-1">
												<img :src="getImageMarketplace(item.platform)" :alt="item.platform" style="width: 30px; margin-right: 5px" />
												<img :src="getEbayMarketplaceFlag(item.marketplace)" :alt="item.marketplace" style="width: 25px" />
												<a :href="item.url" target="_blank" v-if="item.url" class="ml-2 d-flex" title="Apri l'inserzione su eBay"
													><img :src="require(`@/assets/images/www.svg`)" :alt="item.url" style="width: 24px"
												/></a>
											</div>
											<div v-if="item.code"><span class="stack-label">Item ID</span> {{ item.code }}</div>
											<div v-if="item.sellerSku"><span class="stack-label">Seller SKU</span> {{ item.sellerSku }}</div>
										</td>
										<td class="stack-cell ebay-fields">
											<ebay-seller-fields
												:item="item"
												:shipping-items="createListMarketplace(item)"
												@price="changePriceMarketplace"
												@quantity="changeQuantityMarketplace"
												@shipping="changeShippingMarketplace"
											/>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormEdit v-if="operation === 'FormEdit'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormEdit>
			<FormEditVoidEbay
				v-if="operation === 'FormEditVoidEbay'"
				:key="componentKey"
				:variants="editMarketplaceItem?.variants || []"
				:marketplace="editMarketplaceItem?.marketplace || []"
				:variante="Boolean(editMarketplaceItem?.variante)"
				:ebay="editEbay"
				@message="propSetMessages"
			/>
		</v-dialog>
		<v-dialog v-model="dialogconfirmmarketplace" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Confermando l'operazione il prodotto verrà eliminato dal marketplace.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="cancelDeleteMarketplace"> Annulla </v-btn>
					<v-btn color="primary" text @click="confirmDeleteMarketplace"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { openWithReturn } from '@/components/core/pageReturn';
import axios from 'axios';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { regions as regioneEbay } from '@/utils/ebay/marketplace';
import { formatEbayApiError } from '@/utils/ebay/errors';
import CatalogActions from '@/components/marketplace/CatalogActions';
import MarketplaceTabs from '@/components/marketplace/MarketplaceTabs';
const FormEdit = () => import('@/components/items/Edit.vue');
const FormEditVoidEbay = () => import('@/components/items/EditVoidEbay.vue');
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import EbaySellerFields from '@/components/marketplace/EbaySellerFields.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createEbayListTourSteps, stopEbayListTourMenus } from './ebay-list-tour';
export default {
	name: 'EbayItems',
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createEbayListTourSteps(), { onStop: stopEbayListTourMenus }),
		};
	},
	data() {
		return {
			menu: false,
			dialogconfirmUpdate: false,
			componentKey: 0,
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',
			items: [],
			setinterval: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					categories: [],
					brand: {},
					marketplace: '',
					status: '',
				},
				options: {
					sortBy: ['marketplace.data'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],
			marketplaceFilterOptions: [],
			statusFilterOptions: ['Confirmed', 'Void', 'Pending'],
			ebayMarketplaceFulfillmentPolicies: {},
			searchfield: '',
			selected: [],
			selectedall: [],
			total: 0,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Status', value: 'status', sortable: false },
				{ text: 'Creazione', value: 'createdDate', sortable: false },
				{ text: 'Immagine', value: 'image', sortable: false },
				{ text: 'Prodotto', value: 'item', sortable: false },
				{ text: 'eBay', value: 'code', sortable: false },
				{ text: 'Prezzi eBay', value: 'sellerPrice', sortable: false },
			],
			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			dialogconfirm: false,
			dialogconfirmImport: false,
			dialogconfirmmarketplace: false,
			isActive: true,
			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',
			page: 1,
			isMobile: false,
			operation: '',
			editEbay: null,
			editMarketplaceItem: null,
			pendingDeleteMarketplaceItem: null,
			magento: false,
			shopify: false,
			langDefault: '',
			brands: [],
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			currencies: [],
			form: {
				operations: [],
			},
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		/*fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},*/
	},
	async created() {
		this.setDialog(false);
		this.setExistFilter(true);

		let promises = [];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(['ebay']));
		await Promise.all(promises);
		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;
		this.currencies = _.filter(this.getSettings.currencies, { is_active: true });
		this.marketplaceFilterOptions = regioneEbay.map(item => ({
			text: item.marketplace,
			value: item.MarketplaceId,
		}));
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				this.selectedall = [-1];
			}
		},
		'settings.options': {
			handler: function (val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] !== '') {
					let outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.page;

				this.getDataFromApi();
			},
			deep: true,
		},
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		FormEdit,
		FormEditVoidEbay,
		CatalogActions,
		MarketplaceTabs,
		TourOverlay,
		KeyValueCard,
		EbaySellerFields,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		imagePlaceholder() {
			return require(`@/assets/images/picture.svg`);
		},
		selectedLength() {
			return this.selected.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'ebay/getIndex',
			getItems: 'ebay/getItems',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'ebay/getSortBy',
			getSortDesc: 'ebay/getSortDesc',
			getSettings: 'settings/getSetting',
			getServices: 'services/getServices',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		// stessi dati delle colonne Status/Creazione/Prodotto/eBay della tabella desktop
		campiCard(item) {
			const qt = item.qt !== undefined && item.qt !== null ? `${item.qt}${item.qtunit ? ' · unità ' + item.qtunit : ''}` : '';
			const prezzo = this.formatPrice(item.price);
			return [
				{ label: 'Status', value: item.status, strong: true },
				{ label: 'Creazione', value: item.createdDate ? this.$moment(item.createdDate).format('DD/MM/YYYY') : '' },
				{ label: 'SKU', value: item.sku },
				{ label: 'EAN', value: item.ean },
				{ label: 'Qtà', value: qt },
				{ label: 'Prezzo', value: prezzo ? `${prezzo} ${item.currency || ''}`.trim() : '' },
				{ label: 'Item ID', value: item.code },
				{ label: 'Seller SKU', value: item.sellerSku },
			];
		},
		formatPrice(value) {
			if (value === null || value === undefined || value === '' || isNaN(value)) return '';
			return Number(value).toFixed(3);
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setItems: 'ebay/setItems',
			setItem: 'items/setItem',
			setIndex: 'items/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'ebay/asyncFetchData',

			destroyData: 'ebay/destroyData',
			fetchSettings: 'settings/asyncFetchData',
			updateData: 'ebay/updateData',
			setSnackbar: 'settings/updateSnackbar',
			getDetailItem: 'items/getDetailItem',
			getFulfillmentPoliciesV2: 'ebay/getFulfillmentPolicies',
			getEbayOffersV2: 'ebay/getOffers',
			getEbayOfferV2: 'ebay/getOffer',
			updateEbayOfferV2: 'ebay/updateOffer',
			getEbayInventoryItemV2: 'ebay/getInventoryItem',
			createOrReplaceEbayInventoryItemV2: 'ebay/createOrReplaceInventoryItem',
			withdrawEbayOfferV2: 'ebay/withdrawOffer',
			deleteEbayOfferV2: 'ebay/deleteOffer',
			deleteEbayInventoryItemV2: 'ebay/deleteInventoryItem',
			reviseTradingEbayListing: 'ebay/reviseTradingListing',

			fetchService: 'services/getServiceFetch',

			//'resetMessages' : 'settings/resetMessages'
		}),
		changePriceMarketplace(item) {
			Object.assign(item, {
				operation: {
					platform: item.platform,
					marketplaceId: item.marketplace,
					OperationType: 'price',
					code: item.code,
					sku: item.sku,
					sellerSku: item.sellerSku,
					_profile: item._profile,
					_entity: item._entity,
					_item: item._item,
					qt: +item.sellerQt,
					price: +item.sellerPrice,
					currency: item.sellerCurrency,
					shipping: item?.shipping ? item.shipping : '',
					extra: '',
					CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
				},
			});
		},
		changeShippingMarketplace(item) {
			switch (item.platform) {
				case 'Amazon':
					break;
				case 'Ebay':
					this.getItems.forEach(elMark => {
						if (elMark.code === item.code) {
							elMark.shipping = item.shipping;
						}
					});
					break;
			}

			Object.assign(item, {
				operation: {
					platform: item.platform,
					marketplaceId: item.marketplace,
					OperationType: 'shipping',
					code: item.code,
					sku: item.sku,
					sellerSku: item.sellerSku,
					_profile: item._profile,
					_entity: item._entity,
					_item: item._item,
					qt: +item.sellerQt,
					price: +item.sellerPrice,
					currency: item.sellerCurrency,
					shipping: item?.shipping ? item.shipping : '',
					extra: item.item,
					CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
				},
			});
		},
		async getSearch() {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
			this.getDataFromApi();
		},
		applyTableFilters() {
			this.settings.options.page = 1;
			this.getDataFromApi();
		},
		deleteSync(item) {
			this.saveOperation({
				platform: item.platform,
				marketplaceId: item.marketplace,
				OperationType: 'deleteSync',
				code: item.code,
				sku: item.sku,
				sellerSku: item.sellerSku,
				_profile: item._profile,
				_entity: item._entity,
				_item: item._item,
				qt: +item.sellerQt,
				price: +item.sellerPrice,
				currency: item.sellerCurrency,
				shipping: item?.shipping ? item.shipping : '',
				extra: '',
				CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
			});
		},
		deleteMarketplace(item) {
			this.pendingDeleteMarketplaceItem = item;
			this.dialogconfirmmarketplace = true;
		},
		cancelDeleteMarketplace() {
			this.dialogconfirmmarketplace = false;
			this.pendingDeleteMarketplaceItem = null;
		},
		async confirmDeleteMarketplace() {
			if (!this.pendingDeleteMarketplaceItem) {
				this.dialogconfirmmarketplace = false;
				return;
			}

			const item = this.pendingDeleteMarketplaceItem;
			this.dialogconfirmmarketplace = false;
			this.pendingDeleteMarketplaceItem = null;
			this.setPreload(true);
			try {
				const itemMongo = await this.getDetailItem({ id: item._item });
				const detailItem = itemMongo?.data?.data;
				if (!detailItem) {
					throw new Error('Prodotto non trovato');
				}

				const marketplaceItem = Array.isArray(detailItem?.marketplace)
					? detailItem.marketplace.find(marketplaceEntry => _.toString(marketplaceEntry?._id) === _.toString(item._entity)) ||
					  detailItem.marketplace.find(marketplaceEntry => marketplaceEntry?.marketplace === item.marketplace && marketplaceEntry?.sellerSku === item.sellerSku)
					: null;
				if (!marketplaceItem) {
					throw new Error('Riga marketplace non trovata');
				}

				const nextMarketplace = detailItem.marketplace.filter(marketplaceEntry => _.toString(marketplaceEntry?._id) !== _.toString(marketplaceItem?._id));

				if (marketplaceItem.platform === 'Ebay' && marketplaceItem.status === 'Confirmed') {
					await this.deleteEbayMarketplaceItem(marketplaceItem);
				}

				await this.persistMarketplaceRemoval(detailItem, nextMarketplace);
				this.snackbar.color = 'success';
				this.snackbar.text =
					marketplaceItem.platform === 'Ebay' && marketplaceItem.status === 'Confirmed' ? 'Prodotto eliminato da eBay e rimosso dal marketplace locale' : 'Riga marketplace rimossa dal prodotto';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				await this.getDataFromApi();
			} catch (error) {
				this.snackbar.color = 'error';
				this.snackbar.text = this.buildDeleteMarketplaceError(error, 'Errore durante la cancellazione del marketplace');
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 7000;
			} finally {
				this.setPreload(false);
			}
		},
		async editMarketplace(item) {
			if (item?.status !== 'Confirmed') {
				this.snackbar.color = 'error';
				this.snackbar.text = 'La modifica marketplace e disponibile solo per righe Confirmed';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				return;
			}

			this.setPreload(true);
			try {
				const itemMongo = await this.getDetailItem({ id: item._item });
				const detailItem = itemMongo?.data?.data;
				if (!detailItem) {
					throw new Error('Prodotto non trovato');
				}

				const selectedMarketplace = Array.isArray(detailItem?.marketplace)
					? detailItem.marketplace.find(marketplaceItem => _.toString(marketplaceItem?._id) === _.toString(item._entity)) ||
					  detailItem.marketplace.find(marketplaceItem => marketplaceItem?.marketplace === item.marketplace && marketplaceItem?.sku === item.sku)
					: null;

				if (!selectedMarketplace) {
					throw new Error('Riga marketplace non trovata');
				}

				const ebayItem = {
					...selectedMarketplace,
					price: Number(item.sellerPrice || selectedMarketplace.price || 0),
					quantity: Number(item.sellerQt || selectedMarketplace.quantity || 0),
					currency: item.sellerCurrency || selectedMarketplace.currency || this.getEbayMarketplaceDefaultCurrency(selectedMarketplace),
					shipping: item.shipping || selectedMarketplace.shipping || '',
				};

				const esito = await this.updateConfirmedEbayMarketplace(ebayItem, detailItem);
				const righe = ['Operazione effettuata con successo'];
				if (esito?.via === 'trading') {
					righe.push("Inserzione eBay classica: aggiornati prezzo e quantita', la spedizione non viene modificata.");
				}
				(esito?.warnings || []).forEach(avviso => righe.push(`Avviso eBay: ${avviso}`));
				this.snackbar.color = 'success';
				this.snackbar.text = righe.join(' — ');
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				await this.getDataFromApi();
			} catch (error) {
				this.snackbar.color = 'error';
				this.snackbar.text = this.buildDeleteMarketplaceError(error, 'Errore durante l aggiornamento del prodotto su eBay');
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 7000;
			} finally {
				this.setPreload(false);
			}
		},
		async editItem(item) {
			this.componentKey += 1;

			this.setClearError({});
			this.operation = 'FormEdit';

			// la scheda prodotto e' una pagina: ci si va e, salvando o annullando, si torna qui
			// (la pagina carica da se' il dettaglio del prodotto)
			this.setMessages();
			openWithReturn(this, { path: `/items/${item._item}` }, { label: 'Torna a eBay' });
		},
		async saveOperation(item) {
			this.setPreload(true);
			await this.updateData(item);
			this.setPreload(false);
			this.setSnackbar({ color: 'success', text: 'Operazione effettuata con successo', snackbar: true, mode: 'multi-line', timeout: 5000 }, { root: true });

			this.getDataFromApi();
		},

		normalizeIncomingEbayMarketplaceId(marketplaceId = '') {
			const normalized = String(marketplaceId || '')
				.trim()
				.toUpperCase();

			if (normalized === 'EBAY_UK') {
				return 'EBAY_GB';
			}

			return normalized;
		},
		getEbayMarketplaceIdFromItem(item = {}) {
			return this.normalizeIncomingEbayMarketplaceId(item?.marketplace || '');
		},
		getEbayShippingOptions(item) {
			const marketplaceId = this.getEbayMarketplaceIdFromItem(item);
			if (!marketplaceId) {
				return [];
			}

			const policies = this.ebayMarketplaceFulfillmentPolicies[marketplaceId] || [];
			return policies
				.filter(policy => policy.marketplaceId === marketplaceId)
				.map(policy => ({
					value: policy.fulfillmentPolicyId,
					title: policy.name,
				}));
		},
		getEbayMarketplaceConfig(item) {
			const marketplaceId = typeof item === 'string' ? item : this.getEbayMarketplaceIdFromItem(item);
			const marketplaceConfigMap = {
				EBAY_BE: { locale: 'nl_BE', contentLanguage: 'nl-BE', lang: 'nl', currency: 'EUR', productType: 'Product', brand: 'Merk' },
				EBAY_CH: { locale: 'de_CH', contentLanguage: 'de-CH', lang: 'de', currency: 'CHF', productType: 'Produkt', brand: 'Marke' },
				EBAY_DE: { locale: 'de_DE', contentLanguage: 'de-DE', lang: 'de', currency: 'EUR', productType: 'Produkt', brand: 'Marke' },
				EBAY_ES: { locale: 'es_ES', contentLanguage: 'es-ES', lang: 'es', currency: 'EUR', productType: 'Producto', brand: 'Marca' },
				EBAY_FR: { locale: 'fr_FR', contentLanguage: 'fr-FR', lang: 'fr', currency: 'EUR', productType: 'Produit', brand: 'Marque' },
				EBAY_GB: { locale: 'en_GB', contentLanguage: 'en-GB', lang: 'en', currency: 'GBP', productType: 'Product', brand: 'Brand' },
				EBAY_IE: { locale: 'en_IE', contentLanguage: 'en-IE', lang: 'en', currency: 'EUR', productType: 'Product', brand: 'Brand' },
				EBAY_IT: { locale: 'it_IT', contentLanguage: 'it-IT', lang: 'it', currency: 'EUR', productType: 'Prodotto', brand: 'Marca' },
				EBAY_PL: { locale: 'pl_PL', contentLanguage: 'pl-PL', lang: 'pl', currency: 'PLN', productType: 'Produkt', brand: 'Marka' },
				EBAY_NL: { locale: 'nl_NL', contentLanguage: 'nl-NL', lang: 'nl', currency: 'EUR', productType: 'Product', brand: 'Merk' },
				EBAY_AT: { locale: 'de_AT', contentLanguage: 'de-AT', lang: 'de', currency: 'EUR', productType: 'Produkt', brand: 'Marke' },
			};

			return marketplaceConfigMap[marketplaceId] || null;
		},
		getEbayMarketplaceLanguageHeaders(item) {
			const contentLanguage = this.getEbayMarketplaceConfig(item)?.contentLanguage || 'en-GB';

			return {
				'Content-Language': contentLanguage,
				'Accept-Language': contentLanguage,
			};
		},
		getEbayMarketplaceDefaultCurrency(item) {
			return this.getEbayMarketplaceConfig(item)?.currency || 'EUR';
		},
		getTranslatedValue(translations = [], lang = this.langDefault) {
			if (!Array.isArray(translations) || translations.length === 0) {
				return '';
			}

			return translations.find(entry => entry.lang === lang)?.name || translations.find(entry => entry.lang === this.langDefault)?.name || translations[0]?.name || '';
		},
		getEbayMarketplaceDefaultLang(item) {
			return this.getEbayMarketplaceConfig(item)?.lang || this.langDefault || 'it';
		},
		getEbayAspectTargetName(type, item) {
			return this.getEbayMarketplaceConfig(item)?.[type] || (type === 'brand' ? 'Brand' : 'Product');
		},
		buildRequiredEbayInventoryAspects(item, detailItem, existingAspects = {}) {
			const lang = this.getEbayMarketplaceDefaultLang(item);
			const categoryName = this.getTranslatedValue(detailItem?.categories?.[0]?.trans || [], lang);
			const brandName = this.getTranslatedValue(detailItem?.brand?.trans || [], lang);
			const productAspectName = this.getEbayAspectTargetName('productType', item);
			const brandAspectName = this.getEbayAspectTargetName('brand', item);
			const nextAspects = _.cloneDeep(existingAspects || {});

			if (categoryName) {
				nextAspects[productAspectName] = [String(categoryName)];
			}
			if (brandName) {
				nextAspects[brandAspectName] = [String(brandName)];
			}

			return nextAspects;
		},
		// eBay non ha un'offerta Inventory API per lo SKU: 404 "[25713] This Offer is not available"
		isEbayOfferMissing(error) {
			return error?.response?.status === 404 || this.getDeleteMarketplaceErrorIds(error).includes('25713');
		},
		async updateConfirmedEbayMarketplace(item, detailItem) {
			const marketplaceId = this.getEbayMarketplaceIdFromItem(item);
			const ebayHeaders = this.getEbayMarketplaceLanguageHeaders(item);
			let offer = null;
			try {
				const offersData = await this.getEbayOffersV2({
					sku: item.sellerSku,
					marketplace_id: marketplaceId,
				});
				const offers = offersData?.offers || [];
				offer = offers.find(offerItem => offerItem?.marketplaceId === marketplaceId && offerItem?.sku === item.sellerSku) || offers[0];
			} catch (error) {
				if (!this.isEbayOfferMissing(error)) {
					throw error;
				}
			}

			// inserzione creata con la Trading API (la maggior parte): niente offerta, si
			// aggiornano prezzo e quantita' per ItemID. La spedizione qui non si cambia.
			if (!offer?.offerId) {
				const result = await this.reviseTradingEbayListing({
					itemId: detailItem._id,
					entityId: item._id,
					price: Number(item.price || 0),
					quantity: Number(item.quantity || 0),
				});
				return { via: 'trading', warnings: result?.warnings || [] };
			}

			const [offerDetail, inventoryItem] = await Promise.all([
				this.getEbayOfferV2({ offerId: offer.offerId, headers: ebayHeaders }),
				this.getEbayInventoryItemV2({ sku: item.sellerSku, headers: ebayHeaders }),
			]);

			const inventoryPayload = {
				...inventoryItem,
				availability: {
					...(inventoryItem?.availability || {}),
					shipToLocationAvailability: {
						...(inventoryItem?.availability?.shipToLocationAvailability || {}),
						quantity: Number(item.quantity || 0),
					},
				},
			};
			inventoryPayload.product = {
				...(inventoryItem?.product || {}),
				aspects: this.buildRequiredEbayInventoryAspects(item, detailItem, inventoryItem?.product?.aspects || {}),
			};

			const offerPayload = {
				...offerDetail,
				availableQuantity: Number(item.quantity || 0),
				pricingSummary: {
					...(offerDetail?.pricingSummary || {}),
					price: {
						value: String(item.price || 0),
						currency: item.currency,
					},
				},
				listingPolicies: {
					...(offerDetail?.listingPolicies || {}),
					fulfillmentPolicyId: item.shipping || offerDetail?.listingPolicies?.fulfillmentPolicyId || '',
				},
			};

			delete offerPayload.offerId;
			delete offerPayload.listingId;
			delete offerPayload.status;
			delete offerPayload.marketplaceIdEnum;

			await this.createOrReplaceEbayInventoryItemV2({
				sku: item.sellerSku,
				payload: inventoryPayload,
				headers: ebayHeaders,
			});
			await this.updateEbayOfferV2({
				offerId: offer.offerId,
				payload: offerPayload,
				headers: ebayHeaders,
			});
			return { via: 'inventory', warnings: [] };
		},
		async ensureMarketplaceFulfillmentPolicies(marketplaceId) {
			if (!marketplaceId) {
				return [];
			}

			if (this.ebayMarketplaceFulfillmentPolicies[marketplaceId]) {
				return this.ebayMarketplaceFulfillmentPolicies[marketplaceId];
			}

			const fulfillmentData = await this.getFulfillmentPoliciesV2({ marketplace: marketplaceId });
			const policies = fulfillmentData?.fulfillmentPolicies || [];
			this.$set(this.ebayMarketplaceFulfillmentPolicies, marketplaceId, policies);
			return policies;
		},
		async persistMarketplaceRemoval(detailItem, nextMarketplace) {
			const item = { ...detailItem, marketplace: nextMarketplace };
			// come il salvataggio del form prodotto: brand e tag vanno inviati come id, non come oggetti popolati
			const payload = {
				...item,
				brand: item.brand && typeof item.brand === 'object' ? item.brand._id : item.brand,
				tags: _.map(item.tags, tag => (tag && typeof tag === 'object' ? tag._id : tag)),
			};
			await axios.post(`${this.getUrl}items/update`, payload, {
				headers: { Authorization: `Bearer ${this.getToken}` },
			});
			this.setItem(item);
		},
		buildDeleteMarketplaceError(error, fallback = 'Operazione non riuscita') {
			return formatEbayApiError(error, fallback);
		},
		getDeleteMarketplaceErrorIds(error) {
			const details = error?.response?.data?.error?.errors || error?.response?.data?.errors || [];
			if (!Array.isArray(details)) {
				return [];
			}

			return details.map(detail => `${detail?.errorId || ''}`).filter(Boolean);
		},
		async deleteEbayMarketplaceItem(item) {
			const offersData = await this.getEbayOffersV2({
				sku: item.sellerSku,
				marketplace_id: item.marketplace,
			});
			const offers = offersData?.offers || [];
			const offer = offers.find(offerItem => offerItem?.marketplaceId === item.marketplace && offerItem?.sku === item.sellerSku) || offers[0];

			if (!offer?.offerId) {
				throw new Error(`Offer eBay non trovata per marketplace ${item.marketplace} e sku ${item.sellerSku}`);
			}

			let withdrawError = null;
			try {
				await this.withdrawEbayOfferV2({ offerId: offer.offerId });
			} catch (error) {
				const status = error?.response?.status;
				const errorIds = this.getDeleteMarketplaceErrorIds(error);
				const ignorableWithdrawError = status === 404 || status === 409 || errorIds.includes('25001');
				if (!ignorableWithdrawError) {
					throw error;
				}
				withdrawError = error;
			}

			try {
				await this.deleteEbayOfferV2({ offerId: offer.offerId });
			} catch (error) {
				if (withdrawError) {
					throw error;
				}

				throw error;
			}

			const remainingOffersData = await this.getEbayOffersV2({
				sku: item.sellerSku,
			});
			const remainingOffers = (remainingOffersData?.offers || []).filter(offerItem => offerItem?.offerId !== offer.offerId);

			if (remainingOffers.length === 0) {
				await this.deleteEbayInventoryItemV2({ sku: item.sellerSku });
			}
		},
		async syncVisibleMarketplaceShippingPolicies(items = this.getItems) {
			const marketplaceIds = _.uniq(
				(items || [])
					.filter(item => item?.platform === 'Ebay')
					.map(item => this.getEbayMarketplaceIdFromItem(item))
					.filter(Boolean),
			);

			for (const marketplaceId of marketplaceIds) {
				await this.ensureMarketplaceFulfillmentPolicies(marketplaceId);
			}
		},
		createListMarketplace(item) {
			switch (item.platform) {
				case 'Ebay':
					return this.getEbayShippingOptions(item);
				default:
					return [];
			}
		},
		changeQuantityMarketplace(item) {
			Object.assign(item, {
				operation: {
					platform: item.platform,
					marketplaceId: item.marketplace,
					OperationType: 'quantity',
					code: item.code,
					sku: item.sku,
					sellerSku: item.sellerSku,
					_profile: item._profile,
					_entity: item._entity,
					_item: item._item,
					qt: +item.sellerQt,
					price: +item.sellerPrice,
					currency: item.sellerCurrency,
					shipping: item?.shipping ? item.shipping : '',
					extra: '',
					CountryOfOrigin: this.getSettings?.ShippingAddress?.Country ? this.getSettings.ShippingAddress.Country : '',
				},
			});
		},
		getImageMarketplace(img) {
			let logo = '';

			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		getEbayMarketplaceFlag(marketplaceId) {
			const normalizedMarketplaceId = String(marketplaceId || '')
				.trim()
				.toUpperCase();
			if (!normalizedMarketplaceId) {
				return this.getImageFlag('');
			}

			const marketplaceCode = normalizedMarketplaceId.split('_')[1] || '';
			const countryCode = marketplaceCode === 'UK' ? 'GB' : marketplaceCode;

			return this.getImageFlag(countryCode);
		},
		imageUrlAlt(index) {
			this.$refs[index][0].src = require(`@/assets/images/picture.svg`);
		},
		filterCheck(event) {
			this.settings.filters.categories = _.map(event, '_id');
		},
		createImage(item) {
			try {
				return item.image;
			} catch (e) {
				return require(`@/assets/images/picture.svg`);
			}
			//return image;
			//require(`@/assets/images/picture.svg`)
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selected = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] !== -1) {
					this.selected = [];
					_.forEach(this.getItems, cat => {
						this.selected.push(cat._id);
					});
				}
			}
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 2) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),
		propSetMessages(text, value, options) {
			this.snackbar.color = options?.severity === 'error' ? 'error' : 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = options?.severity === 'error' ? 8000 : 5000;
			this.operation = '';
			this.editEbay = null;
			this.editMarketplaceItem = null;
			this.getDataFromApi();
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;

				//const {sortBy, sortDesc, page, itemsPerPage} = this.settings.options
				//console.log("Inizio this.fetchItems")

				let result = await this.fetchItems(this.settings);

				this.total = result.total;
				await this.syncVisibleMarketplaceShippingPolicies();
				//this.items = result.data.data
				this.selected = [];
				this.selectedall = [];
				this.$forceUpdate();

				//console.log(response);
			} catch (err) {
				console.log(err);
			} finally {
				this.setPreload(false);
			}
		},
		async openNew() {
			this.setClearError({});
			//await this.resetMessages();
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		/*checkpresenza(item) {
                return this.selected.includes(item)
            },
*/
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			/*let payload = this.form;
                try {
                    this.setPreload(true);
                    this.preload = true;
                    let response = await this.fetchUsers(payload);

                    this.getDataFromApi().then(res => {

                        this.snackbar.color = "success";
                        this.snackbar.text = this.$vuetify.lang.t(`$vuetify.messages.${data.data}`);
                        this.snackbar.snackbar = true;
                        this.snackbar.mode = 'multi-line';
                        this.snackbar.timeout = 5000;
                        this.setPreload(false);
                    })

                } catch (err) {
                    console.log(err);
                }
                this.preload = false;*/
		},

		deleteItem(item) {
			this.dialogconfirm = true;
			this.form = item;
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
.stack-cell {
	padding-top: 6px !important;
	padding-bottom: 6px !important;
	line-height: 1.35;
}
.stack-title {
	font-weight: 600;
	max-width: 320px;
}
.stack-label {
	font-size: 0.7rem;
	text-transform: uppercase;
	opacity: 0.6;
}
.ebay-fields {
	min-width: 180px;
	padding-top: 8px !important;
	padding-bottom: 8px !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.ebay-cards,
.ebay-cards tr {
	display: block;
	width: 100%;
}
.ebay-cards tr,
.ebay-cards tr:hover {
	background: transparent !important;
}
.ebay-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.ebay-cards tr:first-child td {
	padding-top: 12px !important;
}
.ebay-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.ebay-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
